'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

require('./Announcement.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Announcement = function (_Component) {
  (0, _inherits3.default)(Announcement, _Component);
  (0, _createClass3.default)(Announcement, [{
    key: 'close',
    value: function close(event) {
      event.preventDefault();
      this.props.closeCallback(this.props.data.announcement.id);
    }
  }]);

  function Announcement(props) {
    (0, _classCallCheck3.default)(this, Announcement);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Announcement.__proto__ || (0, _getPrototypeOf2.default)(Announcement)).call(this, props));

    _this.state = { isOpen: true };
    return _this;
  }

  (0, _createClass3.default)(Announcement, [{
    key: 'more',
    value: function more(event) {
      event.preventDefault();
      this.props.moreCallback(this.props.data.announcement.id, this.props.data.announcement.posIds);
    }
  }, {
    key: 'toggle',
    value: function toggle(event) {
      event.preventDefault();
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var __ = this.props.__;
      if (!this.props.data || !this.props.data.announcement) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: (0, _classname2.default)('Announcement', { 'is-closed': !this.state.isOpen }) },
        _react2.default.createElement(
          'div',
          { className: 'Announcement__header' },
          _react2.default.createElement(
            'h2',
            { className: 'Announcement__title' },
            this.props.data.announcement.defaultTitle,
            _react2.default.createElement('span', { className: 'icon-arrow-up' })
          ),
          _react2.default.createElement('a', { href: '#', className: 'Announcement__close icon-cross', onClick: this.close.bind(this) })
        ),
        _react2.default.createElement(
          'div',
          { className: 'Announcement__body' },
          this.props.data.announcement.pictureS3Url && _react2.default.createElement(
            'div',
            { className: 'Announcement__image' },
            _react2.default.createElement('img', { src: this.props.data.announcement.pictureS3Url, alt: '' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'Announcement__content' },
            _react2.default.createElement(
              'div',
              { className: 'Announcement__description' },
              this.props.data.announcement.defaultDescription
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: '#', className: 'Announcement__more', onClick: this.more.bind(this) },
                __('Announcement|Know More')
              )
            )
          )
        )
      );
    }
  }]);
  return Announcement;
}(_react.Component);

Announcement.propTypes = {
  closeCallback: _propTypes2.default.func,
  data: _propTypes2.default.object,
  moreCallback: _propTypes2.default.func
};

Announcement.defaultProps = {
  closeCallback: function closeCallback() {},
  data: null,
  moreCallback: function moreCallback() {}
};

exports.default = (0, _reactTranslate.withTranslator)()(Announcement);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/Announcement/Announcement.js
// module id = 1160
// module chunks = 0